/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/MainProvider';
import SportButtons from '../../atoms/sport-buttons';
import styles from './about-us-buttons.module.scss';

const AboutUsButtons = ({ pageContext }) => {
  const { translations } = useContext(Context) || {};
  return (
    <div>
      <div className={styles.container}>
        <h4>
          {translate(
            translations,
            'choose_your_favourite_sport_and_click_through',
            'Choose your favourite sport and click through'
          )}
        </h4>
      </div>
      <div className={styles.buttons}>
        <SportButtons
          sports={pageContext?.page?.relation?.sports}
          isHeader={false}
          prefix={translate(translations, 'go_to', 'Go to')}
          gtmClass="about-us-gtm"
        />
      </div>
    </div>
  );
};

AboutUsButtons.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({
        sports: PropTypes.arrayOf({}),
      }),
    }),
  }).isRequired,
};

export default AboutUsButtons;
